import { FaRobot, FaBolt, FaCoins, FaComputer } from "react-icons/fa6";
import CustomButton from "shared/components/button/CustomButton";
import { Card, CardContent, CardHeader, Grid, Typography } from "@material-ui/core";
import ativacaoBanner from "static/cloud21/grouppay/ativacaoGroupPay.png";
import stylesAtivacaoGroupPay from "./styles/TelaInicialAtivacaoGroupPayStyles";
import { useContext } from "react";
import { UserContext } from "context/UserContext";
import { usePostCadastrarClienteGroupPay } from "hooks/groupPay/usePostCadastrarClienteGroupPay";

type CardProps = {
  titulo: string;
  content: string;
  icon: React.ReactNode;
  colorIconBackground: string;
};

const TelaInicialAtivacaoGroupPay: React.FC = () => {
  const styles = stylesAtivacaoGroupPay();
  const { usuarioLogado } = useContext(UserContext);
  const { mutateAsync: postCadastrarClienteGroupPay } = usePostCadastrarClienteGroupPay(usuarioLogado.codigoSuporte);

  const cadastrarClienteGroupPay = () => {
    postCadastrarClienteGroupPay(usuarioLogado.codigoSuporte).catch((e) => console.log(e));
  };

  const ButtonPay = ({ label }: { label: string }) => {
    return (
      <div className="mt-4">
        <CustomButton
          id={`${label}`}
          label={label}
          onClick={() => {
            cadastrarClienteGroupPay();
          }}
          size="lg"
        />
      </div>
    );
  };

  const SessaoSaberMais = () => {
    return (
      <>
        <Grid item xs={12} md={7} style={{ padding: 30 }}>
          <Typography variant="h4">
            <span>Automatize o processo de</span>
            <br />
            <span className={styles.titulo}>lançamento de despesas com IA</span>
          </Typography>
          <br />
          <Typography variant="body1">
            Com o <span className={styles.textoDestaque}>Group Pay</span> é possível realizar buscas automáticas de
            notas
            <br />
            fiscais e efetuar lançamentos de forma rápida e eficiente
          </Typography>

          <ButtonPay label="Quero saber mais" />
        </Grid>

        <Grid item xs={12} md={5} className={styles.imagemContainer}>
          <img className={styles.imagemBanner} src={ativacaoBanner} alt="ativacaoGroupPay" />
        </Grid>
      </>
    );
  };

  const CardPay = ({ titulo, content, icon, colorIconBackground }: CardProps) => {
    return (
      <div className={styles.cardContainer}>
        <Card className={styles.card}>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs={12} className={styles.cardHeader}>
                  <div
                    style={{
                      backgroundColor: colorIconBackground,
                      padding: 10,
                      borderRadius: "50%",
                    }}
                  >
                    {icon}
                  </div>
                </Grid>
              </Grid>
            }
          />

          <CardContent>
            <Typography className={styles.tituloCardPay}>{titulo}</Typography>
            <Grid item xs={12} className={styles.contentCard}>
              <Typography>{content}</Typography>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  };

  const CardsInformativos = () => {
    return (
      <Grid container spacing={2} style={{ padding: 30 }}>
        <Grid item xs={12} sm={6} md={3}>
          <CardPay
            titulo="IA no contas a pagar"
            content="Automatize o contas a pagar com busca automática de notas fiscais e boletos na base nacional e e-mails"
            icon={<FaRobot size={45} color="#86de47" />}
            colorIconBackground="#e8f9dc"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardPay
            titulo="Centralize suas despesas"
            content="Centralize despesas de diferentes canais em um único local"
            icon={<FaCoins size={45} color="#de9b47" />}
            colorIconBackground="#f9ecdc"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardPay
            titulo="Garanta agilidade em seus processos"
            content="Automatize seus processos para mitigar riscos de esquecimentos e atrasos"
            icon={<FaBolt size={45} color="#47acde" />}
            colorIconBackground="#dceff9"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardPay
            titulo="Reduza tarefas manuais"
            content="Diminua o tempo buscando e anexando notas de seus condomínios"
            icon={<FaComputer size={45} color="#d96bde" />}
            colorIconBackground="#f7dcf9"
          />
        </Grid>
      </Grid>
    );
  };

  const SessaoDemonstracao = () => {
    return (
      <Grid container className={styles.demonstracaoContainer}>
        <div className={styles.backgroundDemonstracao}>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <ButtonPay label="Quero uma demonstração" />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" className={styles.textoContato}>
              Ficou alguma dúvida? Entre em contato com a
              <a href="https://wa.me/5531983706243" className={styles.linkEntreEmContato} target="_blank">
                {" "}
                nossa equipe.
              </a>
            </Typography>
          </Grid>
        </div>
      </Grid>
    );
  };

  return (
    <>
      <Grid container style={{ display: "flex" }}>
        <SessaoSaberMais />
        <CardsInformativos />
        <SessaoDemonstracao />
      </Grid>
    </>
  );
};

export default TelaInicialAtivacaoGroupPay;
